import { STATUS } from "@/constants/statuses";
import { globalLoggerToken } from "@/tokens";
import { applyTransaction } from "@datorama/akita";
import { Observable, catchError, lastValueFrom, tap } from "rxjs";
import { inject, singleton } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

import CustomerApiService from "../api_services/CustomerApiService";
import CustomerStore from "../stores/CustomerStore";

@singleton()
class CustomerService {
    constructor(
        private readonly customerApiService: CustomerApiService,
        private readonly customerStore: CustomerStore,
        @inject(globalLoggerToken)
        private readonly logger: LoggerInterface
    ) {}

    getCustomerStoreCredit(): Observable<string> {
        const status = this.customerStore.getStatus();
        this.customerStore.setStatus(
            status === STATUS.VIRGIN ? STATUS.INITIAL_LOADING : STATUS.LOADING
        );

        return this.customerApiService.getCustomerStoreCredit().pipe(
            catchError((error: unknown) => {
                this.logger.debug(
                    "CustomerService.getCustomerStoreCredit is errored",
                    error
                );
                this.customerStore.setStatus(STATUS.ERROR);
                throw error;
            }),
            tap((value) => {
                this.logger.debug(
                    "CustomerService.getCustomerStoreCredit is ready"
                );
                //Store Update
                applyTransaction(() => {
                    this.customerStore.update((state) => ({
                        ...state,
                        storeCreditBalance: value,
                    }));
                    this.customerStore.setStatus(STATUS.READY);
                });
            })
        );
    }

    //Use this method when two or more widgets can be injected on the same page to avoid multiple requests
    public async checkRequestStatusAndGetCustomerStoreCredit(): Promise<void> {
        if (this.customerStore.getStatus() === STATUS.VIRGIN)
            await lastValueFrom(this.getCustomerStoreCredit());
    }
}

export default CustomerService;
